namespace RioERP.Products {
    export interface ProductsRow {
        Id?: number;
        ProductName?: string;
        ProductDisplayName?: string;
        Description?: string;
        WebsiteUrl?: string;
        EProductType?: Web.Enums.ProductType;
        ERioplayVersion?: Web.Enums.RioShieldVersion;
        RioplayProductCode?: string;
        SkuCode?: string;
        DownloadUrl1?: string;
        DownloadUrl2?: string;
        TeacherName?: string;
        HasPenDrive?: boolean;
        HasBooks?: boolean;
        IsCombo?: boolean;
        HasCourier?: boolean;
        Note?: string;
        Weight?: number;
        Height?: number;
        Width?: number;
        Length?: number;
        EPackingType?: Web.Enums.PackingType;
        GrossAmount?: number;
        EOpens?: Web.Enums.EOpens;
        EWatchTime?: Web.Enums.EWatchTime;
        EValidity?: Web.Enums.EValidity;
        EValidityType?: Web.Enums.EValidityType;
        TotalAllowedDuration?: number;
        AllowSerialKeyGeneration?: boolean;
        AllowedDevices?: string;
        ProductIds?: string;
        AllowedDevice?: number[];
        ComboProductId?: number[];
        IsLive?: boolean;
        ProcesOrderOnPaid?: boolean;
        ActivateSerialKey?: boolean;
        EAccessStatus?: Web.Enums.AccessStatus;
        InAppDownload?: boolean;
        HasVod?: boolean;
        TemplateSerialKeyId?: number;
        IsActive?: boolean;
        ValidTill?: string;
        ProductCategList?: number[];
        RioPlayTenantId?: number;
        Secretkey?: string;
        RowIds?: string;
        VendorId?: number;
        VendorUserId?: number;
        SupportInfo?: string;
        ProductQueryInfo?: string;
        EShippedby?: Web.Enums.ShippedBy;
        UserName?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ProductsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ProductDisplayName';
        export const localTextPrefix = 'Products.Products';
        export const lookupKey = 'Products.Products';

        export function getLookup(): Q.Lookup<ProductsRow> {
            return Q.getLookup<ProductsRow>('Products.Products');
        }
        export const deletePermission = 'Products:ProductsManagement:Modify';
        export const insertPermission = 'Products:ProductsManagement:Modify';
        export const readPermission = 'Products:ProductsManagement:View';
        export const updatePermission = 'Products:ProductsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            ProductName = "ProductName",
            ProductDisplayName = "ProductDisplayName",
            Description = "Description",
            WebsiteUrl = "WebsiteUrl",
            EProductType = "EProductType",
            ERioplayVersion = "ERioplayVersion",
            RioplayProductCode = "RioplayProductCode",
            SkuCode = "SkuCode",
            DownloadUrl1 = "DownloadUrl1",
            DownloadUrl2 = "DownloadUrl2",
            TeacherName = "TeacherName",
            HasPenDrive = "HasPenDrive",
            HasBooks = "HasBooks",
            IsCombo = "IsCombo",
            HasCourier = "HasCourier",
            Note = "Note",
            Weight = "Weight",
            Height = "Height",
            Width = "Width",
            Length = "Length",
            EPackingType = "EPackingType",
            GrossAmount = "GrossAmount",
            EOpens = "EOpens",
            EWatchTime = "EWatchTime",
            EValidity = "EValidity",
            EValidityType = "EValidityType",
            TotalAllowedDuration = "TotalAllowedDuration",
            AllowSerialKeyGeneration = "AllowSerialKeyGeneration",
            AllowedDevices = "AllowedDevices",
            ProductIds = "ProductIds",
            AllowedDevice = "AllowedDevice",
            ComboProductId = "ComboProductId",
            IsLive = "IsLive",
            ProcesOrderOnPaid = "ProcesOrderOnPaid",
            ActivateSerialKey = "ActivateSerialKey",
            EAccessStatus = "EAccessStatus",
            InAppDownload = "InAppDownload",
            HasVod = "HasVod",
            TemplateSerialKeyId = "TemplateSerialKeyId",
            IsActive = "IsActive",
            ValidTill = "ValidTill",
            ProductCategList = "ProductCategList",
            RioPlayTenantId = "RioPlayTenantId",
            Secretkey = "Secretkey",
            RowIds = "RowIds",
            VendorId = "VendorId",
            VendorUserId = "VendorUserId",
            SupportInfo = "SupportInfo",
            ProductQueryInfo = "ProductQueryInfo",
            EShippedby = "EShippedby",
            UserName = "UserName",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
